const styles = {
  "nav-bar": "_nav-bar_1fp3r_8",
  "nav-bar-items": "_nav-bar-items_1fp3r_14",
  "nav-tab": "_nav-tab_1fp3r_25",
  "nav-item": "_nav-item_1fp3r_47"
};
export {
  styles as default
};
//# sourceMappingURL=Nav.module.css.js.map
